import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as deviceFeaturesService from '../services/deviceFeatures';
import { entitiesAdapter } from './common/adapter';

const initialState = {
  isFetching: false,
  fetchingError: null,
  featureTypes: [],
};

const sliceName = 'deviceFeatures';

export const fetchAllDeviceFeatures = createAsyncThunk(
  `${sliceName}/fetchAllDeviceFeatures`,
  (args, thunkAPI) => {
    return deviceFeaturesService.getDeviceFeatures()
      .catch((error) => {
        error.clientMessage = "Can't get device features from server";
        return thunkAPI.rejectWithValue(error);
    });
  }
);

const deviceFeatures = createSlice({
  name: sliceName,
  initialState: entitiesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: {
    [fetchAllDeviceFeatures.fulfilled]: (state, action) => {
      state.isFetching = false;
      entitiesAdapter.setAll(state, action);
    },
    [fetchAllDeviceFeatures.pending]: (state) => {
      state.isFetching = true;
      state.fetchingError = null;
    },
    [fetchAllDeviceFeatures.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
  },
});

const { reducer } = deviceFeatures;

const deviceFeaturesAdapterSelectors = entitiesAdapter.getSelectors(
  (state) => state[sliceName]
);

export const deviceFeaturesSelectors = {
  ...deviceFeaturesAdapterSelectors,
  isFetching: (state) => state[sliceName].isFetching,
  fetchingError: (state) => state[sliceName].fetchingError,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/deviceFeaturesSlice.js